import './LoginHeader.css'
import { Button } from '@mantine/core'
import { useAuth0 } from '@auth0/auth0-react';
import { useConfigContext } from '../../../contexts/ConfigContext/ConfigContextProvider';

export default function LoginHeader() {
   const { loginWithRedirect } = useAuth0();
   const { jsonTexts, jsonBranding } = useConfigContext()
   const texts = jsonTexts?.login?.heading
   return (
      <header className='LoginPage-header-container'>
         <figure className='LoginPage-header--group'>
            < img className='LoginPage-header--logo' src={jsonBranding.logo} alt='logo' />
         </figure>
         <div className='LoginPage-header--group'>
            <Button size="lg" radius='md' color='var(--color-primary)' onClick={() => loginWithRedirect()}>{texts?.loginButtonText}</Button>
         </div>
      </header>
   )
}
